import React from "react";

import theme from "@/foundation/Theme";

import {
  CTAButton,
  Description,
  DownloadButton,
  Heading,
  LHSSection,
  RHSSection,
  StyledFloatingBanner,
  WrapContainer,
} from "./style";

function FloatingBanner({ hideBanner, controls, onDownloadButtonClick }) {
  const NotNowCTA = (
    <CTAButton
      variant="outline"
      borderColor={theme.colors.white}
      hoverColor={theme.colors.white}
      TextColor={theme.colors.white}
      onClick={hideBanner}
    >
      Not now
    </CTAButton>
  );

  const DownloadCTA = (
    <DownloadButton key="downloadButton" animate={controls}>
      <CTAButton
        variant="primary1"
        bgColor={theme.colors.white}
        hoverColor={theme.colors.white}
        TextColor={theme.colorsV2.primary.shade_800}
        onClick={onDownloadButtonClick}
      >
        Switch to the app
      </CTAButton>
    </DownloadButton>
  );

  return (
    <StyledFloatingBanner
      key="floatingBanner"
      initial={{ opacity: 0, y: "100%" }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: "100%" }}
      transition={{ duration: 0.3 }}
    >
      <WrapContainer py="16px" alignItems="center">
        <LHSSection flexDirection="column">
          <Heading
            variant="heading5"
            fontSize="16px"
            lineHeight="24px"
            fontFamily="var(--man-700)"
          >
            Shyft is better on the app
          </Heading>
          <Description
            variant="heading6"
            fontSize="16px"
            lineHeight="24px"
            fontFamily="var(--man-400)"
          >
            Never miss a post. Open this post in Shyft app to get full
            experience.
          </Description>
        </LHSSection>
        <RHSSection>
          {NotNowCTA}
          {DownloadCTA}
        </RHSSection>
      </WrapContainer>
    </StyledFloatingBanner>
  );
}

export default FloatingBanner;
